import { useEffect, useState } from "react"
import { CiMicrophoneOn   } from "react-icons/ci";
import './Styles/style.css'
import { imedix_pic } from "../constants/imports";

import { IoIosArrowBack  } from "react-icons/io";
import { cloud_services, hardware_solutions, ict_installations, it_support, software_solutions } from "./Constants";
import { IoSend,  } from "react-icons/io5"
import { useDispatch, useSelector } from "react-redux";
function Response(data) {

    return <div id="responss" className={data.type}>
        {data.m.map((e, key) => {
            var loading = data.l && key == 3 ? 'animate-pulse' : ''
            return (e.content != '' ? <p className={e.role == 'bot' ? `botm ${loading}` : 'userm'} key={key}>{e.content}</p> : '')
        }
        )
        
        
        }

{data.l && <p className={`botm animate-pulse `}>...</p>}
    </div>
}

export default function Chatbotview(props) {



    async function get_message(msg, setres, setloading) {
        console.log('value', msg)

        const apiUrl = 'https://rwncahtbotapi.onrender.com/message';

        const requestBody = [
            {
                "role": "system",
                "content":  `You are an AI assistant that is an expert in medical health and is part of a hospital system called medicare AI
                You know about symptoms and signs of various types of illnesses.
                You can provide expert advice on self diagnosis options in the case where an illness can be treated using a home remedy.
                if a query requires serious medical attention with a doctor, recommend them to book an appointment with our doctors
                If you are asked a question that is not related to medical health respond with "Im sorry but your question is beyond my functionalities".
                do not use external URLs or blogs to refer
                Format any lists on individual lines with a dash and a space in front of each line.`
                       


            },
            {
                "role": "system",
                "content": "Give the best health advice"
            },
            {
                "role": "system",
                "content": msg
            }
        ];

        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(requestBody),
        })
            .then(response => response.json())
            .then(data => {
                console.log('Response from server:', data.message.content);
                setres(data.message.content)
                setloading(false)
                return data.message.content;

            })
            .catch(error => {
                setres("Opps, an error ocoured, check your internet connection")
                console.error('Error:', error);
            });

    }


   var dispatcher =useDispatch()


    var data = [{ li: 'Contact Support' }, {
        li:
  'Software Solutions'
    },
    { li: 'Hardware Solutions' },
    { li: 'Cloud Services' },
    { li: 'ICT Installation Services' },
    { li: 'IT Support' }]
    var default_message = (<div className=""><p>Please tell us what you are looking for:</p><ul>

        {data.map((value, key) => (<li onClick={()=>handlechoice(key)} className=" rounded-lg text-[13px] mt-2 active:bg-customBlue active:text-white text-[#666666] font-bold flex justify-center p-1 bg-[#fefefe]">{value.li}</li>))}
    </ul>
    </div>)
    var [botmsg, setbotmsg] = useState("")
    var [inputvvv, setinput] = useState('')
    var [userin, setusi] = useState('')
    var [inv, setinv] = useState('')
    var [isloading, setisloading] = useState(false)

var state_msgs =useSelector((state)=>state.messages)
   var messages  = state_msgs

    useEffect(() => {

       
if(!userin==''){
scrolldown()
setTimeout(() => {
    scrolldown()
}, 200);

}
    
    }, [botmsg, userin])







useEffect(()=>{
    if(!(botmsg=='' || botmsg=='...')){
        dispatcher({type:'add_message', payload:  { role: 'bot', content: botmsg }})
    }
    
    
    },[botmsg])



 function handlechoice(key){

        if(key==0) 
        {setbotmsg(<>Thank you for reaching out, please call +2349066005044 or send us an email on info@rwndynamics.com</>)
    setusi(data[key].li)
    }
    if(key==1){
        setbotmsg(software_solutions)
        setusi(data[key].li)
    }
    if(key==2){
        setbotmsg(hardware_solutions)
        setusi(data[key].li)
    }

    if(key==3){
        setbotmsg(cloud_services)
        setusi(data[key].li)
    }
    if(key==4){
        setbotmsg(ict_installations)
        setusi(data[key].li)
    }
    if(key==5){
        setbotmsg(it_support)
        setusi(data[key].li)
    }
     }



    function scrolldown() { 

        var element = document.getElementById('scroll-conatiner');
    
       element.scrollTop = element.scrollHeight;
     }
    function scrollup() {

        var element = document.getElementById('scroll-conatiner');
        if (element) {
            element.scrollTop = 0;
        }

    }
    async function sendmsg() {


        scrolldown()

        setinv('')

        dispatcher({type:'add_message', payload: { role: 'user', content: inputvvv } })
        var rg = await get_message(inputvvv, (e)=>{

          setbotmsg(e)
          scrolldown() 
        }, setisloading)
        setbotmsg('...')
        setisloading(true)


    }


    return <div className='chatbot-view  my-8 '>
        <div className="bot-header py-6  px-3 ">

            <IoIosArrowBack  onClick={() => {
                scrollup()
                setbotmsg('')
                setusi('')
                setinv('')
                setinput('')

            }} size={'1em'} className="rounded-lg active:bg-[grey]" />

          <img className='w-20 m-15' src={imedix_pic}  />
        </div>

        <div className="main-chat">
            <div id='scroll-conatiner' className="msgs">

                <Response l={isloading} m={messages} />
                
            </div>


            <div className="type-msg">
                 <CiMicrophoneOn  onClick={()=>{ 

                }} className="rounded-lg active:bg-[grey]" color='#293586' size={'1.5em'} />
                <input value={inv} onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        sendmsg()
                    }
                }}
                    onChange={(e) => {
                         scrolldown()
                        setinv(e.target.value)
                        setinput(e.target.value)
                        setusi(e.target.value)



                    }} placeholder="Type your message here..." type="text" id='input' className="type-in" />
                <IoSend className="rounded-lg active:bg-[grey]" color='#293586' size={'1.5em'}
                    onClick={
 
                        sendmsg
 
                    } class="fa-solid fa-paper-plane" />
            </div>

        </div>
    </div>
}